import Loading from "components/Loading";
import Permission from "components/Permission";
import React, { Suspense } from "react";
import { Route } from "react-router-dom";
import { MODULE_NOTIFICATION } from "shared/constants";
import PermissionDeniedPage from "components/PermissionDenied";

const Notification = React.lazy(
  () => import("containers/ServiceManagement/Notification")
);

function NotificationRoute() {
  return (
    <Route
      path="notification"
      element={
        <Suspense fallback={<Loading loading />}>
          <Permission
            children={<Notification />}
            permissionDenied={<PermissionDeniedPage />}
            modules={[MODULE_NOTIFICATION]}
          />
        </Suspense>
      }
    />
  );
}

export default NotificationRoute;
